import {createSelector} from 'reselect';

export const getAccountPageSelector = state => state.accountPage;

export const isLoadingSelector = createSelector(
    getAccountPageSelector,
    page => page.isLoading
);
